








































































import Vue, { PropType } from "vue";
import { StorePaymentConfiguration, StorePaymentConfigurationType } from "@/common/models/StorePaymentConfiguration";
import { FieldRules } from "@/common/utils/FieldRules";

export default Vue.extend({
  name: "PaymentConfigurationEdit",
  props: {
    model: {
      type: Object as PropType<StorePaymentConfiguration>,
      required: true,
    },
  },
  data() {
    return {
      StorePaymentConfigurationType,
      typeValues: Object.values(StorePaymentConfigurationType).map((type) => {
        return { text: type, value: type };
      }),
      ...FieldRules,
    };
  },
});
